import {Box, Flex, Image, Text, Button} from '@chakra-ui/react'
import FireWork from '@assets/svgs/gym/firework.svg'
import Title from '@assets/svgs/gym/title.svg'
import {useLocation, useNavigate} from 'react-router-dom'
import {useDispatch} from 'react-redux'

import {
  updatePronounceDataSpeech,
  updatePairDataSpeech,
  updatePracticeDataSpeech,
  upDateTotalPronounceRecording,
  upDateTotalPracticeRecording,
  upDateTotalPairRecording,
} from '@redux/gym/gymSlice'
import {PATH} from '@utils/Const'

const GymResultPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {entry_point, task_id} = useLocation().state || {}

  const handleEnd = () => {
    dispatch(updatePronounceDataSpeech(null))
    dispatch(updatePairDataSpeech([]))
    dispatch(updatePracticeDataSpeech(null))
    dispatch(upDateTotalPronounceRecording(0))
    dispatch(upDateTotalPairRecording({}))
    dispatch(upDateTotalPracticeRecording(0))
    if (entry_point === 'ROADMAP') {
      navigate(PATH.ROADMAP_SUMMARY, {
        state: {
          task_id,
        },
      })
    } else {
      navigate(PATH.GYM)
    }
  }

  return (
    <Box minH={'100vh'} bg={'#D1E9FF'}>
      <Flex
        h={'64px'}
        bg={'white'}
        justifyContent={'center'}
        alignItems={'center'}>
        <Image src={Title} h={'24px'} />
      </Flex>
      <Box px={'16px'}>
        <Flex
          borderRadius={'16px'}
          overflow={'hidden'}
          mx={'auto'}
          mt={'90px'}
          flexDirection={'column'}
          alignItems={'center'}
          maxW={'580px'}
          bg={'white'}>
          <Text
            fontSize={'24px'}
            fontWeight={600}
            bg={'#003D75'}
            py={'13px'}
            align={'center'}
            color={'white'}
            w={'100%'}>
            Bạn đã làm rất tốt!
          </Text>
          <Image w={'80px'} h={'80px'} mt={'30px'} src={FireWork} />
          <Box my={'16px'}>
            <Text fontSize={'16px'} fontWeight={600} align={'center'}>
              Tiếp tục học để giỏi hơn nhé
            </Text>
            <Text fontSize={'16px'} fontWeight={600} align={'center'}>
              Remember, practice makes perfect
            </Text>
          </Box>
          <Flex justifyContent={'center'}>
            <Button
              bg={'#1890FF'}
              color={'white'}
              mb={'30px'}
              onClick={handleEnd}>
              Hoàn thành
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Box>
  )
}

export default GymResultPage
